import { ScopeType } from "../../data-structures/enums";
import { ErrorHelper } from "./ErrorHelper";

/** The sign-in popup EditTenantPanel has always opened the consent page in. */
const CONSENT_WINDOW_NAME = "SignInWindow";
const CONSENT_WINDOW_FEATURES = "width=600,height=600,location=no,menubar=no,toolbar=no";

/**
 * The Portal's own /consent page for one tenant and scope type. Consent.tsx exchanges it for
 * Microsoft's /adminconsent URL through api/portal/Consent/ConsentUrl, so the same link works when a
 * partner sends it to the customer's administrator (spec 2026-10-13 §4).
 */
export const adminConsentPageUrl = (origin: string, tenantId: string, scopeType: ScopeType): string => {
    const trimmedOrigin = origin.trimEnd();
    const url = new URL(`${trimmedOrigin.endsWith("/") ? trimmedOrigin.slice(0, -1) : trimmedOrigin}/consent`);
    url.searchParams.append("tid", tenantId);
    url.searchParams.append("sct", scopeType.toString());
    return url.toString();
};

/**
 * Opens the consent page for this Portal's origin. This is EditTenantPanel.openAdminConsentWindow's
 * body, moved here unchanged so the panel's consent buttons and the Copilot section share it.
 */
export const openAdminConsentPage = (tenantId: string, scopeType: ScopeType): void => {
    try {
        window.open(adminConsentPageUrl(window.location.origin, tenantId, scopeType), CONSENT_WINDOW_NAME, CONSENT_WINDOW_FEATURES);
    } catch (error) {
        ErrorHelper.handle(error);
    }
};
